<template>
  <div class="FormReviewImport">
    <FormValidation class="searchForm" @submit="findLaptops">
      <RowGrid :columns="['1fr', '16rem']">
        <Field
          :label="$t('url')"
          :value.sync="reviewImport.url" />
        <!--
        <Field
          :doExpand="false"
          :label="$t('html')"
          type="textarea"
          :value.sync="reviewImport.html" />
        -->
        <RowFlex>
          <Btn
            class="info"
            icon="search"
            :isLoading="isSearching"
            type="submit">
            {{ $t('search') }}
          </Btn>
          <a
            v-if="reviewImport.url"
            class="Btn info light"
            :href="reviewImport.url"
            :isLoading="isSearching"
            rel="noopener noreferrer"
            target="_blank"
            type="submit">
            <Icon name="open" />
            {{ $t('open') }}
          </a>
        </RowFlex>
      </RowGrid>
      <ReviewExternal
        v-if="laptopParsed"
        :reviewExternal="laptopParsed.reviewsExternal[0]" />
      <RowFlex v-if="laptopParsed" class="constrainButtons">
        <div>
          <Btn class="light" @click="isModalOpen = true">
            {{ $t('edit') }}
          </Btn>
          <ModalForm
            v-if="isModalOpen"
            @close="isModalOpen = false"
            @submit="setLaptopParsed(laptopParsedStatic)">
            <FormLaptop
              :laptop.sync="laptopParsedStatic" />
            <Btn type="submit">
              {{ $t('update') }}
            </Btn>
          </ModalForm>
        </div>
        <BtnReviewWatch
          v-if="reviewExternal"
          :reviewExternal.sync="laptopParsed.reviewsExternal[0]" />
      </RowFlex>
      <LaptopMatched
        v-for="(laptop, index) in laptops"
        :key="laptop.id"
        :incoming="laptopParsed"
        :original="laptop"
        @update:original="setLaptop(index, $event)" />
    </FormValidation>
  </div>
</template>

<script>
import BtnReviewWatch from './BtnReviewWatch'
import FormLaptop from '@components/forms/FormLaptop'
import LaptopMatched from './LaptopMatched'
import ModalForm from '@components/modals/ModalForm'
import ReviewExternal from '@components/ReviewExternal'
import { actions } from '@utils'
import { detach } from '@utils/objects'
import { omit } from 'rambda'
import { pluckId } from '@utils/collections'

export default {
  components: {
    BtnReviewWatch,
    FormLaptop,
    LaptopMatched,
    ModalForm,
    ReviewExternal,
  },
  props: {
    reviewImport: { type: Object, required: true },
  },
  data() {
    return {
      isModalOpen: false,
      isSearching: false,
      laptopParsed: null,
      laptopParsedStatic: null,
      laptops: [],
    }
  },
  computed: {
    reviewExternal() {
      return this.laptopParsed?.reviewsExternal?.[0]
    },
  },
  methods: {
    findLaptops() {
      return this.$wrap(
        async () => {
          this.laptopParsed = null
          this.laptops = []

          const [{ laptopParsed, laptops }] = await this
            .FIND_REVIEW_IMPORT(this.reviewImport)

          this.laptopParsed = laptopParsed
          this.laptopParsedStatic = detach(laptopParsed)
          this.laptops = laptops

          await this.FETCH_MISSING_FILE(pluckId('imageFileId', laptops))
        },
        'isSearching',
      )
    },
    setLaptop(index, laptop) {
      this.$set(this.laptops, index, laptop)
    },
    async setLaptopParsed(laptop) {
      const laptopDetached = detach(laptop)
      const [reviewExternal] = laptopDetached.reviewsExternal

      this.laptops = await this.FIND_PRODUCT_SIMILARITY_SEARCH({
        product: laptopDetached,
      })

      if (reviewExternal.id) {
        await this.PATCH_REVIEW_EXTERNAL({
          id: reviewExternal.id,
          product: omit(['reviewsExternal'], laptopDetached),
        })
      }

      this.laptopParsed = laptopDetached
      this.isModalOpen = false
    },
    ...actions(
      'FETCH_MISSING_FILE',
      'FIND_PRODUCT_SIMILARITY_SEARCH',
      'FIND_REVIEW_IMPORT',
      'PATCH_REVIEW_EXTERNAL',
    ),
  },
}
</script>

<style lang="scss">
.FormReviewImport {
  .searchForm {
    padding: $u;

    .Field-cont {
      margin: 0;
    }

    .Btn {
      align-self: flex-end;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "edit": "Edit",
    "html": "HTML",
    "open": "Open",
    "search": "Search",
    "update": "Update parsed data",
    "url": "URL"
  }
}
</i18n>
